import React, {useState} from "react";
import {Box} from "@mui/material";

export const ListExpandable = ({ fullText }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!fullText) return "N/A";

    const items = fullText.split(';').map(item => item.trim()).filter(item => item !== "");

    if (items.length <= 1) {
        return <span>{items[0] || "N/A"}</span>;
    }

    const displayedItems = isExpanded ? items : [items[0]];

    return (
        <Box component="span">
            {displayedItems.map((item, index) => (
                <span key={index} style={{ display: 'block' }}>
                    {item}
                </span>
            ))}
            <span
                onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(!isExpanded);
                }}
                style={{
                    cursor: 'pointer',
                    color: '#299CDB',
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    display: 'inline-block',
                    marginTop: '4px'
                }}
            >
                {isExpanded ? "Voir moins" : `+ Voir les ${items.length - 1} autres`}
            </span>
        </Box>
    );
};